import { ErrorResponse } from "./types";

const isErrorResponse = (data: any): data is ErrorResponse =>
    (data as ErrorResponse)?.message !== undefined &&
    (data as ErrorResponse)?.code !== undefined;

export default isErrorResponse;
